export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2024-08-29T04:43:11.859Z",
    "Last-Translator": "",
    "Language-Team": "",
    "Language": "en-US",
    "Messages": {
        "3": "3",
        "5": "5",
        "10": "10",
        "-": "",
        "...nie znalazłeś widgetu? Dodaj nowy.": "...Didn't find a widget? Add a new one.",
        "${props.title}": "${props.title}",
        "${statusIndex === 0 ? 'Powrót' : 'Powrót do edycji artykułu'}": "${statusIndex === 0 ? ' Back' : 'Back to article editing'}",
        "Aby nastąpiła automatyczna akceptacja regulaminu, wybrana wersja musi mieć status „Do akceptacji”.": "",
        "Adres": "Address",
        "Adres docelowy": "Destination address",
        "Adres domenowy": "Domain address",
        "Adres domeny": "Domain address",
        "Adres kanoniczny": "Canonical address",
        "Adres strony": "Website address",
        "Adres url": "Url",
        "Adres URL": "URL",
        "Adres url do pliku wideo": "Url to video file",
        "Adres URL profilu autora.": "URL of the author profile.",
        "Adres źródłowy": "Source address",
        "Akceptacja komentarzy": "Accept comments",
        "Akceptuj": "Accept",
        "Aktualności": "News",
        "Aktualności ze strony": "Website news",
        "Aktywacja kont po rejestracji": "Activation of accounts after registration",
        "Aktywne": "Active",
        "Aktywne do": "Active to",
        "Aktywne od": "Active since",
        "Aktywne teraz": "Active now",
        "Aktywny": "Active",
        "Aktywuj przerwę techniczną w witrynie": "Activate the site's technical break",
        "Alfabetycznie": "Alphabetically",
        "Ankieta": "Survey",
        "Ankieta wyświetli się w miejscu wskazanym w treści artykułu. Aby je wskazać wybierz element \"Ankieta\" z narzędzi edytora": "",
        "Ankiety": "Surveys",
        "Anulowane": "Canceled",
        "Anuluj": "Cancel",
        "Anuluj edycję": "Undo",
        "AQL": "",
        "Aranżacja alternatywna": "Alternative arrangement",
        "Aranżacja domyślna": "Default arrangement",
        "Aranżacja główna": "Main arrangement",
        "Aranżacja została dodana.": "The arrangement has been added.",
        "Aranżacja została skopiowana.": "",
        "Aranżacja została usunięta.": "The arrangement has been deleted.",
        "Aranżacja została zaktualizowana.": "The arrangement has been updated.",
        "Aranżacje": "Arrangements",
        "Archiwum": "Archive",
        "Artykuł": "Article",
        "Artykuł otwarty": "Open article",
        "Artykuł premium": "Premium Article",
        "Artykuł sponsorowany": "Sponsored article",
        "Artykuły": "Articles",
        "Artykuły oznaczone jako \"Śródtekstowe\" wyświetlą się w miejscu wskazanym w treści artykułu. Aby je wskazać wybierz element \"Powiązane artykuły\" z narzędzi edytora": "",
        "Artykuły ze statusem PRIORYTET": "Articles with PRIORITY status",
        "Asystenta AI": "AI Assistant",
        "Automat paczkowy": "",
        "Automatyczna akceptacja": "Auto acceptance",
        "Automatyczna akceptacja komentarzy zalogowanych użytkowników": "Automatic acceptance of comments from logged-in users",
        "Automatyczna akceptacja wszystkich komentarzy": "Automatic acceptance of all comments",
        "Automatyczna publikacja galerii": "Automatic publication of galleries",
        "Automatyczny": "Automatic",
        "Autor": "Author",
        "Autor nie może zostać usunięty, ponieważ jest przypisany do artykułów": "The author cannot be removed because he is assigned to articles",
        "Autor został dodany.": "The author added.",
        "Autor został usunięty.": "The author has been removed.",
        "Autor został zaktualizowany.": "The author has been updated.",
        "Autorzy": "Authors",
        "Autorzy artykułu": "",
        "Autorzy spoza bazy użytkowników": "Authors outside the user base",
        "Baner został dodany.": "The banner has been added.",
        "Baner został zaktualizowany.": "The banner has been updated.",
        "Banery": "Banners",
        "Banner został usunięty.": "The banner has been removed.",
        "Barwa tekstu": "Text color",
        "Barwa tła": "Background color",
        "Baza dokumentów": "Document database",
        "Bez \"http(s)://\" i \"/\" na końcu.": "No \"http(s)://\" and \"/\" at the end.",
        "Bezpieczeństwo": "Safety",
        "Bezpieczny adres URL": "Secure URL",
        "Blik": "BLIK payments",
        "Widget aktywny": "Active widget",
        "Widget jest wyłączony dla tej witryny": "The widget is disabled for this site",
        "Widget służy do wczytania ustawień wiadomości email według wybranej witryny i wersji językowej.": "",
        "Widget unikalny może zostać użyty tylko raz": "A unique widget can only be used once",
        "Widget został skopiowany do wskazanej witryny.": "",
        "Widget został usunięty.": "The widget has been removed.",
        "Widgety": "Widgets",
        "Błąd płatności": "",
        "Brak": "Lack",
        "Brak artykułów": "No articles",
        "Brak autorów": "",
        "Brak czołówki": "No www page header",
        "Brak danych": "No data",
        "Brak dodanych plików": "No files added",
        "Brak etykiety": "No label",
        "Brak kategorii": "No categories",
        "Brak kategorii nadrzędnej": "No parent category",
        "Brak listy regulaminów": "No list of regulations",
        "Brak modułu": "No module",
        "Brak odpowiedzi dla ankiety": "",
        "Brak plików do dodania": "No files to add",
        "Brak potwierdzenia": "No confirmation",
        "Brak powiązań": "No connection",
        "Brak stron": "No pages",
        "Brak strony nadrzędnej": "No parent page",
        "Brak wybranych autorów": "No selected authors",
        "Browse files": "Browse files",
        "Browse links": "Browse links",
        "Cena": "Price",
        "Cena brutto": "Gross price",
        "Cena została wyłączona z historii.": "Price has been excluded from the story.",
        "Chronologia zdarzeń": "Chronology of events",
        "CMS": "CMS",
        "Co godzinę": "Every hour",
        "Co miesiąc": "Every month",
        "Co rok": "Every year",
        "Co tydzień": "Every week",
        "Codziennie": "Every day",
        "Czas na slajd": "Time per slide",
        "Czas na stronie": "Time on page",
        "Czas po jakim zamówienie wygaśnie": "Time after which the order will expire",
        "Czas po jakim zamówienie zostanie anulowane": "Time after which the order will be cancelled",
        "Czas został zaktualizowany.": "The time has been updated.",
        "Czas życia cacheu w sekundach": "",
        "Częstotliwość odświeżania": "Refresh rate",
        "Czołówka": "Headline",
        "Czołówka została dodana.": "The lead has been added.",
        "Czołówka została usunięta.": "The lead has been removed.",
        "Czołówka została zaktualizowana.": "The lead has been updated.",
        "Czwartek": "Thursday",
        "Czy chcesz ją przywrócić?": "Do you want to bring it back?",
        "Czytać mogą tylko zalogowani użytkownicy": "Only logged-in users can read it",
        "Dalsza część artykułu przeznaczona jest dla osób z subskrypcją premium": "",
        "Dane autoryzacyjne Google Analytics": "",
        "Dane autoryzacyjne powinny być przekazane w formacie JSON, który można uzyskać z pliku autoryzacyjnego utworzonego z klucza dostępowego na platformie Google Cloud": "",
        "Dane do faktury": "Invoice data",
        "Dane klienta": "Customer details",
        "Data": "Date",
        "Data akceptacji": "Acceptance date",
        "Data automatycznej akceptacji": "Auto acceptance date",
        "Data dezaktywacji": "Deactivation date",
        "Data do": "Date to",
        "Data dodania": "Adding date",
        "Data i godzina": "Date and hour",
        "Data informująca o terminie wejścia w życie tego regulaminu.": "The date informing about date of entry into force of these regulations.",
        "Data modyfikacji": "Modification date",
        "Data modyfikacji:": "Modification date:",
        "Data od": "Date from",
        "Data odrzucenia": "Rejection date",
        "Data opłacenia": "Date of payment",
        "Data ostatniego użycia": "Date of last use",
        "Data publikacji": "Publication date",
        "Data publikacji:": "Publication date:",
        "Data rejestracji": "Registration date",
        "Data rezygnacji": "Date of resignation",
        "Data rozpoczęcia": "Start date",
        "Data subskrypcji": "Subscription date",
        "Data wprowadzenia": "Date of introduction",
        "Data wydania": "Release date",
        "Data wygaśnięcia": "Expiration date",
        "Data zakończenia": "End date",
        "Data zakończenia publikacji nie może być wcześniejsza, niż jej rozpoczęcie": "",
        "Data zapisania się": "Date of enrollment",
        "Data zgłoszenia": "Notification date",
        "Daty publikacji": "",
        "Daty publikacji zostały zaktualizowane.": "The publication dates have been updated.",
        "Definicja szablonu": "Template definition",
        "Dla procesu zakupowego": "For the purchasing process",
        "Długość": "Length",
        "Dni": "Days",
        "Do odebrania w punkcie": "",
        "Do poziomu": "To level",
        "Docelowa strona": "Target page",
        "Dodaj": "Add",
        "Dodaj aranżację": "Add an arrangement",
        "Dodaj autora": "Add author",
        "Dodaj baner": "Add banner",
        "Dodaj czołówkę": "Add a headlamp",
        "Dodaj do zestawu": "Add to set",
        "Dodaj dokument": "Add the document",
        "Dodaj etykietę": "Add tag",
        "Dodaj galerię": "Add gallery",
        "Dodaj gazetkę": "Add newspaper",
        "Dodaj grupę": "Add group",
        "Dodaj katalog": "Add directory",
        "Dodaj kategorie": "Add category",
        "Dodaj kategorię": "Add category",
        "Dodaj kolejne słowo": "Add another word",
        "Dodaj kolejny element": "Add another element",
        "Dodaj kolejny powód": "Add another reason",
        "Dodaj link": "Add link",
        "Dodaj nowa kategorię": "Add a new category",
        "Dodaj nową witrynę aby rozpocząć zarządzanie stronami.": "Add a new website to start managing your pages.",
        "Dodaj nowy katalog aby rozpocząć zarządzanie stronami.": "Add a new directory to start managing your pages.",
        "Dodaj nowy tag": "Add new tag",
        "Dodaj odpowiedź": "Add answer",
        "Dodaj opinię": "Add feedback",
        "Dodaj plik": "Add a file",
        "Dodaj przekierowanie": "Add redirection",
        "Dodaj pytanie": "Add question",
        "Dodaj rotator": "Add rotator",
        "Dodaj shortcode": "",
        "Dodaj ShortCode": "",
        "Dodaj slajd": "Add slide",
        "Dodaj slajder": "Add slider",
        "Dodaj stronę": "Add page",
        "Dodaj szablon": "Add template",
        "Dodaj wideo": "Add video",
        "Dodaj witrynę": "Add website",
        "Dodaj wpis": "Add entry",
        "Dodaj wzór": "",
        "Dodaj zestaw": "Add set",
        "Dodane pliki z sortowaniem": "Added files with sorting",
        "Dodane przez": "Added by",
        "Dodane przez moje zespoły": "Added by my teams",
        "Dodane przeze mnie": "Added by me",
        "Dodanie aktualności": "Add news",
        "Dodanie ankiety": "Add surveys",
        "Dodanie aranżacji": "Adding an arrangement",
        "Dodanie artykułu": "Add article",
        "Dodanie autora": "Addition of author",
        "Dodanie baneru": "Adding a banner",
        "Dodanie czołówki": "Adding a headlamp",
        "Dodanie dokumentu": "Addition of document",
        "Dodanie etykiety": "Add tag",
        "Dodanie galerii": "Adding a gallery",
        "Dodanie gazetki": "Adding a newspaper",
        "Dodanie grupy": "Adding a group",
        "Dodanie kategorii": "Add category",
        "Dodanie linku": "Add link",
        "Dodanie linku wewnętrznego": "Adding an internal link",
        "Dodanie pakietu": "Adding a package",
        "Dodanie poradnika": "Add guide",
        "Dodanie regulaminu": "Add regulations",
        "Dodanie rotatora": "Adding a rotator",
        "Dodanie slajdera": "Add slider",
        "Dodanie strony": "Add page",
        "Dodanie szablonu": "Add template",
        "Dodanie top tematu": "Adding a top topic",
        "Dodanie wideo": "Adding video",
        "Dodanie witryny": "Add website",
        "Dodanie wzoru": "",
        "Dodanie zestawu regulaminów": "Add set of regulations",
        "Dodano za dużo stron (maksymalnie %0).": "",
        "Dodatkowe parametry w adresie URL": "",
        "Dokument": "Document",
        "Dokument nie jest jeszcze nigdzie opublikowany.": "The document has yet not been published anywhere.",
        "Dokument nie ma ustawionej daty publikacji.": "The document does not have a publication date set.",
        "Dokument został dodany.": "Document has been added.",
        "Dokument został usunięty.": "The document has been removed.",
        "Dokument został wysłany do publikacji.": "The document has been sent for publication.",
        "Dokument został zaktualizowany.": "The document has been updated.",
        "Dokumenty": "Documents",
        "Dołącz stronę do pliku sitemap.xml": "Add the page to the sitemap file.xml",
        "Domyślna": "Default",
        "Domyślna stopka": "",
        "Domyślna witryna": "Default site",
        "Domyślne logo": "",
        "Domyślne ustawienie dla witryny": "Default site setting",
        "Domyślny": "Default",
        "Domyślny tytuł aktywnej strony": "Default title of the active page",
        "Dostarczone": "",
        "Dostawa": "Delivery",
        "Dostępna jest zapisana wersja robocza dokumentu.": "A saved draft version of the document is available.",
        "Dostępne dla": "Available for",
        "Dostępne języki": "Available languages",
        "Dostępne moduły": "Available modules",
        "Dostępne wersje językowe.": "Available language versions.",
        "Dostępny w sekcjach": "Available in sections",
        "Drugi klucz - md5": "Second key - md5",
        "Drugie powiadomienie": "Second notification",
        "Duplikuj": "Duplicate",
        "Duplikuj aranżację": "",
        "Dzień tygodnia": "",
        "E-mail": "E-mail",
        "Edycja": "Edit",
        "Edycja aktualności": "Edit news",
        "Edycja ankiety": "Edit survey",
        "Edycja aranżacji": "Edit arrangement",
        "Edycja artykułu": "Edit article",
        "Edycja autora": "Author's edit",
        "Edycja baneru": "Banner editing",
        "Edycja czołówki": "Headline Edition",
        "Edycja dokumentu": "Edit document",
        "Edycja etykiety": "Edit label",
        "Edycja galerii": "Gallery editing",
        "Edycja gazetki": "Newspaper edition",
        "Edycja grupy": "Group edit",
        "Edycja kategorii": "Edit category",
        "Edycja komentarza": "Edit comment",
        "Edycja linku": "Edit link",
        "Edycja linku wewnętrznego": "Edit internal link",
        "Edycja pakietu": "Editing the package",
        "Edycja poradnika": "Edit guide",
        "Edycja regulaminu": "Edit regulations",
        "Edycja rotatora": "Edit rotator",
        "Edycja slajdera": "Edit slider",
        "Edycja strony": "Edit page",
        "Edycja szablonu": "Edit template",
        "Edycja top tematu": "Edit top topic",
        "Edycja ustawień": "Edit settings",
        "Edycja wideo": "Video editing",
        "Edycja witryny": "Edit site",
        "Edycja wzoru": "",
        "Edycja zestawu regulaminów": "Editi set of regulations",
        "Edytuj": "Edit",
        "Edytuj aranżację": "Edit arrangement",
        "Edytuj aranżację alternatywną": "",
        "Edytuj widget": "Edit widget",
        "Edytuj katalog": "Edit directory",
        "Edytuj kategorię": "Edit category",
        "Edytuj komentarz": "Edit comment",
        "Edytuj obszar": "Edit area",
        "Edytuj rotator": "Edit rotator",
        "Edytuj shortcode": "",
        "Edytuj slajder": "Edit slider",
        "Edytuj stronę": "Edit page",
        "Edytuj tag": "Edit tag",
        "Edytuj wpis": "Edit post",
        "Brak powiązanych wpisów dla tego widgetu.": "There are no linked entries for this widget.",
        "Nie udało się pobrać powiązanych wpisów dla tego widgetu.": "Failed to load linked entries for this widget.",
        "Ładowanie elementów...": "Loading entries...",
        "Ładowanie podglądu...": "Loading preview...",
        "Dodaj widget do sekcji": "Add widget to section",
        "Sekcja docelowa": "Target section",
        "Brak dostępnych typów widgetów.": "There are no available widget types.",
        "Jesteś w drugim dialogu: edycja wpisu.": "You are in the second dialog: entry editing.",
        "Pod spodem nadal masz otwarty podgląd aranżacji.": "The arrangement preview dialog is still open underneath.",
        "Możesz bezpiecznie zamknąć ten dialog, aby wrócić do podglądu.": "You can safely close this dialog to return to the preview.",
        "Widget źródłowy": "Source widget",
        "Edytuj zestaw": "Edit set",
        "Email": "E-mail",
        "Email użytkownika": "User email",
        "Etykieta": "Tag",
        "Etykieta została dodana.": "The label has been added.",
        "Etykieta została usunięta.": "The label has been removed.",
        "Etykieta została zaktualizowana.": "The label has been updated.",
        "Etykiety": "Tags",
        "Export": "Export",
        "Facebook Admins": "Facebook Admins",
        "Facebook Application ID": "Facebook Application ID",
        "FavIcona": "Favicon",
        "Film": "Film",
        "Film z YouTube": "YouTube video",
        "Filtry": "Filters",
        "Firma": "Company",
        "Folder został usunięty.": "The folder has been deleted.",
        "Forma płatności": "Form of payment",
        "Format pliku": "File format",
        "Formularz": "Modules / Contact form",
        "Formularz kontaktowy": "Contact form",
        "Formularz nie istnieje.": "",
        "Fraza": "Phrase",
        "Galeria": "Gallery",
        "Galeria nie jest jeszcze nigdzie opublikowana.": "The gallery is not yet published anywhere.",
        "Galeria nie ma ustawionej daty publikacji.": "The gallery does not have a publication date set.",
        "Galeria zdjęć": "Photo gallery",
        "Galeria zdjęć premium": "Premium photo gallery",
        "Galeria została dodana.": "The gallery has been added.",
        "Galeria została usunięta.": "The gallery has been removed.",
        "Galeria została zaktualizowana.": "The gallery has been updated.",
        "Gazetka": "Newspaper",
        "Gazetka nie jest jeszcze nigdzie opublikowana.": "The newspaper is not yet published anywhere.",
        "Gazetka nie ma ustawionej daty publikacji.": "The newspaper does not have a set publication date.",
        "Gazetka została dodana.": "The newspaper has been added.",
        "Gazetka została usunięta.": "The newspaper has been removed.",
        "Gazetka została zaktualizowana.": "The newspaper has been updated.",
        "Generowanie stron gazetek...": "Generating newspaper pages...",
        "Generuj nowe sitemapy": "Generate new sitemaps",
        "Generuj strony gazetki": "Generate newspaper pages",
        "Generuj wszystkie metadane": "Generate all metadata",
        "Godzina": "",
        "Google Maps": "",
        "Grupa": "Group",
        "Grupa banerów została dodana.": "The banner group has been added.",
        "Grupa banerów została usunięta.": "The banner group has been removed.",
        "Grupa banerów została zaktualizowana.": "The banner group has been updated.",
        "Grupy": "Groups",
        "Historia cen": "Price history",
        "Historia wyszukiwania": "",
        "i posiadających wymagane uprawnienia": "and having the required permissions",
        "Id": "Id",
        "ID": "ID",
        "Id punktu płatności - posId": "Id of the payment point - posId",
        "ID wątku": "",
        "Identyfikator usługi Google Analytics": "",
        "Ikona": "Icon",
        "Ikona wyświetlana jest w postaci kwadratu.": "The icon is displayed in the form of a square.",
        "Ile dni przed zakończeniem subskrypcji autoodnawialnej rozpocznie się pobranie płatności": "How many days before the end of the auto-renewal subscription will start collecting payment",
        "Ile razy system ponawia płatność": "How many times the system renews the payment",
        "Ilość artykułów w kategorii": "Number of articles in the category",
        "Ilość dni przed": "",
        "Ilość dostępnych widgetów": "Number of available widgets",
        "Ilość kolumn podkategorii": "",
        "Ilość powtórzeń po wystąpieniu błędu": "",
        "Ilość publikacji: %0": "",
        "Ilość wybranych stron: %0": "",
        "Ilość wyświetlanych aktualności": "Number of news updates displayed",
        "Ilość wyświetlanych artykułów": "Number of articles displayed",
        "Ilość wyświetlanych tagów": "Number of tags displayed",
        "Ilość zaakceptowanych regulaminów: ": "",
        "Imię": "First name",
        "Imię i Nazwisko": "First name and last name",
        "Imię i nazwisko/nazwa autora": "Name of author",
        "Import": "Imports",
        "Indeksowanie strony": "Page indexing",
        "Informacja o ciasteczkach": "Information about cookies",
        "Informacje o zamówieniu": "Order information",
        "Inspekcja": "Inspection",
        "Integracje": "",
        "Interakcja użytkownika (Komenatrze, Like)": "User Interaction (Comenats, Like)",
        "ISBN": "ISBN",
        "Jeśli danego użytkownika nie ma na liście, oznacza to, że brakuje podstawowych danych takich jak Imię i Nazwisko. Uzupełnij te dane w dziale Użytkownicy.": "If a particular user is not on the list, it means that basic data such as First Name and Last Name are missing. Fill in this data in the Users section.",
        "Jeśli pole jest puste to wstawiana automatycznie.": "If the field is empty, the value is inserted automatically.",
        "Język": "Language",
        "Język domyślny": "Default language",
        "Karta": "Card",
        "Katalog": "Directory",
        "Katalog linków": "Links directory",
        "Katalog został utworzony.": "The directory has been created.",
        "Kategoria": "Category",
        "Kategoria linku": "Link category",
        "Kategoria nadrzędna": "Parent category",
        "Kategoria subskrypcji": "Subscription category",
        "Kategoria subskrypcji została dodana.": "The subscription category has been added.",
        "Kategoria subskrypcji została usunięta.": "The subscription category has been removed.",
        "Kategoria subskrypcji została zaktualizowana.": "The subscription category has been updated.",
        "Kategoria urządzenia": "",
        "Kategoria została dodana.": "The category has been added.",
        "Kategoria została usunięta.": "The category has been removed.",
        "Kategoria została zaktualizowana.": "The category has been updated.",
        "Kategorie": "Categories",
        "Kategorie linków": "Link categories",
        "Kategorie subskrypcji": "",
        "Kategorię": "Category",
        "Kategorię można opublikować tylko na jednej stronie.": "A category can only be published on one page.",
        "Kategorię subskrypcji": "Subscription category",
        "Klienci": "Clients",
        "Kobieta": "Woman",
        "Kod bannera (tutaj wklej kod HTML i JS)": "Banner code (paste HTML and JS code here)",
        "Kod Bing Webmaster": "Bing Webmaster Code",
        "Kod Google Webmaster": "Google Webmaster Code",
        "Kod GTM": "GTM code",
        "Kod HTML": "HTML code",
        "Kod pocztowy": "Postal code",
        "Kolejne pozycje z lewej strony": "Next items on the left",
        "Kolejne pozycje z prawej strony": "Next items on the right",
        "Kolor tekstu": "Text color",
        "Kolor tła": "Background color",
        "Komentarz": "Comments",
        "Komentarz %0": "Comment %0",
        "Komentarz do wyłączenia ceny": "Comments on price exclusion",
        "Komentarze": "Comments",
        "Komunikat mailowy": "E-mail message",
        "Konfiguracja": "Settings",
        "Konfiguracja aranżacji jest niedostępna ponieważ nie podano definicji szablonu.": "The arrangement configuration is not available because no template definition is provided.",
        "Konfiguracja asystenta ai": "Configuring the ai assistant",
        "Konfiguracja widgetów jest niedostępna ponieważ nie podano definicji szablonu.": "Widget configuration is not available because no template definition is provided.",
        "Konfiguracja widgetu": "Widget configuration",
        "Konfiguracja widgetu została zapisana.": "The widget configuration has been saved.",
        "Konfiguracja sekcji jest niedostępna ponieważ nie podano definicji szablonu.": "Section configuration is not available because no template definition is provided.",
        "Konfiguracja shortcode": "",
        "Konfiguruj stronę": "Configure page",
        "Konto publiczne": "Public account",
        "Kontynent": "",
        "kopia": "",
        "Kopiuj": "Copy",
        "Kopiuj do innej witryny": "",
        "Kopiuj do witryny": "",
        "Koszyk": "",
        "Kraj": "Country",
        "Krótki opis": "Short description",
        "Krótki tytuł": "Short title",
        "Książka": "Book",
        "Kurier": "",
        "Layout": "",
        "Liczba": "Number",
        "Liczba ankiet": "",
        "Liczba artykułów": "Number of articles",
        "Liczba slajdów widoczna dla użytkownika nie może być większa od liczby slajdów dodanych w panelu.": "The number of slides visible to the user cannot be greater than the number of slides added in the panel.",
        "Liczba wyników": "",
        "Liczba wyników na stronie": "Number of results per page",
        "Liczba wyświetlanych najnowszych elementów": "Number of recent elements displayed",
        "Liczba wyświetlanych slajdów": "Number of slides displayed",
        "Liczba wyświetleń": "Number of displays",
        "Liczba zamówień": "Number of orders",
        "Liczba zgłoszeń:": "Number of requests:",
        "Like do komentarzy mogą dodawać tylko zalogowani użytkownicy": "Like to comments can only be added by logged-in users",
        "Limit zgłoszeń": "Request limit",
        "Limit znaków dla niezalogowanych": "Character limit for not logged in users is required",
        "Limit znaków dla zalogowanych": "Character limit for logged-in users is required",
        "Limity": "Limits",
        "Linia ciągła": "",
        "Linia falująca": "",
        "Linia kreskowana": "",
        "Linia kropkowana": "",
        "Link": "Link",
        "Link do strony": "Website link",
        "Link do wybranej strony serwisu": "Link to the selected page of the website",
        "Link do zewnętrznej strony": "Link to external site",
        "Link wewnętrzny został dodany.": "The internal link has been added.",
        "Link wewnętrzny został usunięty.": "The internal link has been removed.",
        "Link wewnętrzny został zaktualizowany.": "The internal link has been updated.",
        "Link wygasł": "Link expired",
        "Link z serwisu": "Link from the site",
        "Link został dodany.": "Link has been added.",
        "Link został usunięty.": "The link has been removed.",
        "Link został zaktualizowany.": "The link has been updated.",
        "Linki wewnętrzne": "Internal links",
        "Linki wewnętrzne zostały pomyślnie połączone.": "The internal links have been successfully connected.",
        "Lista": "",
        "Lista artykułów": "List of articles",
        "Lista banerów": "List of banners",
        "Lista dostępnych zmiennych, które można wykorzystać we wszystkich polach tekstowych:": "List of available variables that can be used in all text fields:",
        "Lista jest pusta": "The list is empty",
        "Lista komentarzy": "Comments list",
        "Lista linków": "Links list",
        "Lista publikacji": "",
        "Lista regulaminów": "Regulation list",
        "Logo": "Logo",
        "Ładowanie zgłoszeń...": "Loading submissions...",
        "Maksymalna ilość stron": "",
        "Maksymalna szerokość strony to 1410": "The maximum page width is 1410",
        "Maksymalna wysokość strony to 1080": "The maximum page height is 1080",
        "Marketing": "Marketing",
        "Metadane": "Metadata",
        "Metryka": "",
        "Mężczyzna": "Man",
        "Miasto": "City",
        "Miesiące": "Months",
        "Miniatura zdjęcia": "",
        "Minimalna szerokość strony to 370": "The minimum page width is 370",
        "Minimalna wysokość strony to 500": "The minimum page height is 500",
        "Moduł": "Module",
        "Moduł dynamiczny": "Dynamic module",
        "Moduł konfigurowalny": "Configurable module",
        "Moduły": "Modules",
        "Moduły wyszukiwarki": "Search engine modules",
        "Monitoring": "Monitoring",
        "Multimedia": "Multimedia",
        "Multimedia premium": "Premium multimedia",
        "Multimedia przypisane do artykułu": "",
        "Naciśnij enter aby usunąć": "Press enter to delete",
        "Naciśnij enter aby wybrać": "Press enter to select",
        "Najniższa cena brutto z 30 dni przed obniżką": "The lowest gross price from 30 days before the reduction",
        "Najniższy": "Lowest",
        "Najpierw dodaj stronę do gazetki.": "First, add the site to the newspaper.",
        "Najpierw zapisz wprowadzone zmiany": "",
        "Najpopularniejsze strony": "",
        "Najwięcej czasu spędzone na stronach": "",
        "Najwyższy": "Highest",
        "Najwyższy poziom": "",
        "Narzędzia": "Tools",
        "Nazwa": "Name",
        "Nazwa adresu": "",
        "Nazwa aktywnej strony": "Active page name",
        "Nazwa aranżacji": "Arrangement name",
        "Nazwa widgetu": "Widget name",
        "Nazwa cechy": "Feature name",
        "Nazwa certyfikatu": "Certificate name",
        "Nazwa czołówki": "Headlamp name",
        "Nazwa etapu": "",
        "Nazwa etykiety": "Label name",
        "Nazwa grupy": "Group name",
        "Nazwa kategorii": "Category name",
        "Nazwa Kategorii": "Category Name",
        "Nazwa linku": "Link name",
        "Nazwa pakietu": "Package name",
        "Nazwa pliku": "File name",
        "Nazwa płyty": "Disc name",
        "Nazwa rotatora": "Rotator name",
        "Nazwa sekcji": "Section name",
        "Nazwa shortcode": "",
        "Nazwa slajdera": "Slider name",
        "Nazwa slajdu": "Slide name",
        "Nazwa strony": "Page name",
        "Nazwa szablonu": "Template name",
        "Nazwa użytkownika": "User name",
        "Nazwa w panelu": "Name in panel",
        "Nazwa wewnętrzna": "Internal name",
        "Nazwa witryny": "Site name",
        "Nazwa wyświetlana": "Display name",
        "Nazwa wyświetlana:": "Display Name:",
        "Nazwa zduplikowanej aranżacji": "",
        "Nazwa zestawu": "Set name",
        "Nazwa:": "Name:",
        "Nazwisko": "Last name",
        "Nie": "No",
        "Nie ma jeszcze żadnych rekordów": "",
        "Nie można już edytować tego linku wewnętrznego, ponieważ jest on aktualnie używany.": "This internal link can no longer be edited, as it is currently in use.",
        "Nie pokazuj krótkiego opisu strony w wynikach wyszukiwania (NoSnippet)": "Do not show a short description of the page in search results (NoSnippet)",
        "Nie pokazuj linku do archiwum strony (NoArchive)": "Do not show a link to the archive of the page (NoArchive)",
        "Nie pokazuj strony jako źródła grafiki w wynikach wyszukiwania (NoImageIndex)": "Do not show the page as an image source in search results (NoImageIndex)",
        "Nie pomocna": "",
        "Nie posiadasz uprawnień do edycji tego artykułu.": "You do not have permission to edit this article.",
        "Nie udało się pobrać kategorii": "Failed to download category",
        "Nie udało się pobrać listy aranżacji": "Failed to download the arrangement list",
        "Nie udało się pobrać listy widgetów": "Failed to download widget list",
        "Nie udało się pobrać listy etykiet": "Failed to download label list",
        "Nie udało się pobrać listy kategorii": "Failed to download category list",
        "Nie udało się pobrać listy modułów": "Failed to download module list",
        "Nie udało się pobrać listy modułów wyszukiwarki": "Failed to download list of search engine modules",
        "Nie udało się pobrać listy regulaminów": "Failed to download the list of regulations",
        "Nie udało się pobrać listy stron": "Failed to download the pages list",
        "Nie udało się pobrać listy szablonów": "Failed to download template list",
        "Nie udało się skopiować aranżacji.": "",
        "Nie udało się skopiować widgetu.": "",
        "Nie udało się ustawić aranżacji domyślnej": "",
        "Nie udało się załadować ankiet.": "",
        "Nie udało się załadować widgetu Google Analytics.": "",
        "Nie udało się załadować widgetu ostatnich użytkowników.": "",
        "Nie wybrano authora.": "No author has been selected.",
        "Nie wybrano strony": "No page has been selected",
        "Nie wybrano żadnej kategorii": "No category was selected",
        "Nie zdefiniowano żadnych sekcji.": "No sections are defined.",
        "Nie znaleziono opublikowanej aranżacji.": "",
        "Nie znaleziono żadnych folderów.": "No folders were found.",
        "Nie znaleziono żadnych wyników.": "No results found.",
        "Nie związana": "",
        "Nieaktywne": "Inactive",
        "Nieaktywny": "Inactive",
        "Niedostępne widgety": "Unavailable widgets",
        "Niedozwolone słowa": "Unpermitted words",
        "Niedziela": "Sunday",
        "Nieopłacone": "",
        "Niepotwierdzona": "",
        "Niestandardowy adres": "Non-standard address",
        "Niestandardowy adres strony": "Non-standard page address",
        "Niestandardowy nagłówek": "Custom header",
        "Nieudana próba doręczenia": "",
        "Nieznany status": "",
        "Nigdy": "Never",
        "NIP": "Tax ID Number",
        "Niski": "Low",
        "Niżej": "Below",
        "Nofollow": "Nofollow",
        "Nowa aranżacja": "",
        "Nowa cena brutto": "New gross price",
        "Nowa cena do": "New price to",
        "Nowa cena od": "The new price from",
        "Nowa kategoria": "",
        "Nowe sitemapy zostały wygenerowane.": "New sitemaps have been generated.",
        "np. pl-PL": "i.e., pl-PL",
        "Number": "Number",
        "Numer": "Number",
        "Numer aktywnej strony": "Active page number",
        "Numer domu/mieszkania": "House/apartment number",
        "Numer telefonu": "Phone number",
        "Obraz": "Image",
        "Obsługa cacheu dla witryny": "",
        "Oczekujący na akceptację": "Awaiting approval",
        "Oczekuje na płatność": "Awaiting payment",
        "Oczekuje na potwierdzenie": "Awaiting confirmation",
        "Oczekuje na weryfikację": "",
        "Oczekuje na wysyłkę": "",
        "Oczekuje na zatwierdzenie": "Awaiting approval",
        "Od poziomu": "From level",
        "Odebrane w punkcie": "",
        "Odnośnik URL": "URL reference",
        "Odpowiedzi": "Responses",
        "Odpowiedź": "Answer",
        "Odrzucone zgody": "Rejected consents",
        "Odrzucony po zgłoszeniach": "Rejected after requests",
        "Odrzuć": "Reject",
        "Odznacz wszystkie": "Unselect all",
        "Ogólny": "",
        "Okładka": "Cover",
        "Okładka do wideo premium": "Coverage for premium video",
        "Określa z której strony do ścieżki mają być dodawane kolejne pozycje.": "Specifies where you want to add additional items to the path.",
        "Open Graph": "Open Graph",
        "Operator płatności": "Payment operator",
        "Opinia": "Opinion",
        "Opis": "Description",
        "Opis przerwy technicznej": "Description of the technical break",
        "Opis sekcji": "Section description",
        "Opis witryny": "Site description",
        "Opłacone": "",
        "Opublikowane": "Published",
        "Opublikowane języki": "Published languages",
        "Opublikowane wersje językowe.": "Published language versions.",
        "Opublikowany na stronach": "Published on pages",
        "Opublikuj": "Publish",
        "Opublikuj autora": "Publish author",
        "Ostatni miesiąc": "",
        "Ostatni rok": "",
        "Ostatni tydzień": "",
        "Ostatnia aktualizacja:": "Last updated:",
        "Oś czasu": "Timeline",
        "Otwieraj w nowym oknie": "Open in new window",
        "Otwórz stronę w nowym oknie": "Open the page in a new window",
        "Otwórz w nowej karcie": "",
        "Oznacz jako opłacone": "Mark as paid",
        "Pakiet": "Package",
        "Pakiet aktywny": "Active package",
        "Pakiet autoodnawialny": "Auto-renewable package",
        "Pakiet został dodany.": "The package has been added.",
        "Pakiet został zaktualizowany.": "The package has been updated.",
        "Pakiety": "Packages",
        "Parametry email": "",
        "PayU": "PayU",
        "Pełna strona": "Full page",
        "Pełna treść:": "Full content:",
        "Pełny adres aktywnej strony": "Full address of the active site",
        "Pełny adres wraz z \"http(s)://\".": "Full address including \"http(s)://\".",
        "Piątek": "Friday",
        "Pierwsza strona z listy jest identyfikowana przez system jako CANONICAL, czyli informuje roboty wyszukiwarki, która ze zduplikowanych stron jest tą z oryginalną treścią.": "The first page in the list is identified by the system as CANONICAL, which means it tells search engine robots which of the duplicate pages is the one with the original content.",
        "Pierwsze powiadomienie": "First notification",
        "Pierwsze zdjęcie w galerii jest zdjęciem głównym": "The first photo in the gallery is the main photo",
        "Piosenka": "Song",
        "Pisać mogą tylko zalogowani użytkownicy": "Only logged-in users can write",
        "Plik": "File",
        "Plik gazetki (PDF)": "Newspaper file (PDF)",
        "Plik gazetki do pobrania (PDF)": "Newspaper file to download (PDF)",
        "Plik graficzny": "Image file",
        "Plik wideo": "Video file",
        "Pliki": "Files",
        "Pliki do dodania": "Files to add",
        "Płatność": "",
        "Płeć": "Gender",
        "Płyta z muzyką": "Music CD",
        "Po aktywacji wejście na dowolną stronę frontową przez użytkownika w obrębie witryny wyświetli informację o trwającej przerwie technicznej. Witryna podczas przerwy technicznej dla użytkowników z uprawnieniami administratora jest zawsze dostępna.": "Once activated, accessing any front page by a user within the site will display information about the ongoing technical break. The site during a technical break for users with administrator privileges is always accessible.",
        "Po zapisaniu artykułu w wybranej wersji językowej, nie będzie możliwości jej zmiany.": "",
        "Pobierz wyniki": "Download the results",
        "Poczta": "Mail",
        "Podaj adres url...": "Enter the url...",
        "Podaj identyfikatory użytkowników Facebooka, oddzielone przecinkami, aby mogli uzyskać dostęp do statystyk (Facebook Insights).": "Provide Facebook user IDs, separated by commas, so they can access to their statistics (Facebook Insights).",
        "Podążanie za linkami": "Links following",
        "Podgląd": "Preview",
        "Live design": "Live design",
        "Podgląd artykułu": "Article preview",
        "Podgląd strony": "Page preview",
        "Podłącz linki wewnętrzne": "Connect internal links",
        "Podstawowe": "Basic",
        "Podstawowe informacje": "",
        "Podwójna linia ciągła": "",
        "Pojedyncza publikacja": "",
        "Pojedynczy artykuł (strona opisowa)": "Single article (descriptive page)",
        "Pojedyńcza, prosta, ciągła linia": "",
        "Pokaż etykietę": "Show tag",
        "Pole \"%0\" jest wymagane.": "Field ''%0'' is required.",
        "Pole \"Ilość dni przed\" jest wymagane.": "",
        "Pole \"Język\" jest wymagane.": "",
        "Pole \"Metryka\" jest wymagane.": "",
        "Pole \"Nazwa\" jest wymagane.": "",
        "Pole \"Sortuj według\" jest wymagane.": "",
        "Pole \"Witryna\" jest wymagane.": "",
        "Pole \"Wymiar\" jest wymagane.": "",
        "Pole identyfikujące dokument": "",
        "Polubienia": "",
        "Pomoc": "Help",
        "Pomocna": "",
        "Poniedziałek": "Monday",
        "Popularność": "Popularity",
        "Po otwarciu listy widzisz pierwsze wyniki. Wpisz początek wartości z pola identyfikującego, aby zawęzić listę.": "After opening the list, you see the first results. Type the beginning of the value from the identifying field to narrow the list.",
        "Potwierdzenie mailowe": "Email confirmation",
        "Potwierdzenie mailowe i akceptacja administratora": "Email confirmation and administrator approval",
        "Potwierdzenie przywrócenia": "Confirmation of restoration",
        "Potwierdzenie usunięcia": "Deletion confirmation",
        "Potwierdzenie wysłania": "Confirmation of dispatch",
        "Potwierdzenie zatwierdzenia": "Approval confirmation",
        "Potwierdzone": "Confirmed",
        "Potwierdź": "Confirm",
        "Potwierdź akceptację": "Confirm acceptance",
        "Potwierdź przywrócenie wersji roboczej": "Confirm restoration of draft version",
        "Potwierdź usunięcie": "Confirm deletion",
        "Powiadomienia": "Notifications",
        "Powiązana galeria": "Related gallery",
        "Powiązana kategoria": "Related category",
        "Powiązane artykuły": "Related articles",
        "Powiązane galerie": "Related galleries",
        "Powiązane kategorię": "Related Categories",
        "Powiązane wideo": "Related video",
        "Powiązany artykuł": "Related article",
        "Powiązany autor": "Related author",
        "Powód": "Reason",
        "Powrót": "Back",
        "Powrót do edycji strony": "Back to page editing",
        "Pozostałe ustawienia": "Other settings",
        "Premiera": "Premiere",
        "Premium": "Premium",
        "Premium otwarty": "Premium open",
        "Prezentacja": "",
        "Priorytet": "Priority",
        "Procent": "Percentage",
        "Produkcyjne": "Manufacturing",
        "Profil użytkownika": "Profile",
        "Protokół OAuth - clientId": "OAuth protocol - clientId",
        "Protokół OAuth - clientSecret": "OAuth protocol - clientSecret",
        "Przeciągnij do innej sekcji": "Drag to another section",
        "Przeciągnij do wybranej sekcji": "Drag to the desired section",
        "Przeglądarka": "",
        "Przejdź do konfiguracji, aby włączyć narzędzia": "Go to configuration to enable tools",
        "Przekierowania": "Redirects",
        "Przekierowanie aktywne": "Redirection active",
        "Przekierowanie zostało dodane.": "Redirection has been added.",
        "Przekierowanie zostało usunięte.": "The redirect has been removed.",
        "Przekierowanie zostało zaktualizowane.": "The redirection has been updated.",
        "Przenieś do sekcji": "Move to section",
        "Przenieś niżej": "Move lower",
        "Przenieś wyżej": "Move higher",
        "Przerwa techniczna": "Technical break",
        "Przesuń do góry": "Move up",
        "Przesuń w dół": "Move down",
        "Przywróć": "Reload",
        "Przywróć zaznaczone": "",
        "Pseudonim": "Pseudonym",
        "Publiczne": "Public",
        "Publiczne ID:": "Public ID:",
        "Publikacja": "Publication",
        "Publikacja galerii przez użytkownika": "Publication of galleries by user",
        "Publikacja priorytetowa": "Priority publication",
        "Publikacja zarchiwizowana": "Archived publication",
        "Publikacja została dodana.": "The publication has been added.",
        "Publikacja została usunięta.": "The publication has been deleted.",
        "Publikuj do": "Publish to",
        "Publikuj na stronie": "Publish to page",
        "Publikuj na wybranej stronie": "Publish on the site of your choice",
        "Publikuj od": "Publish from",
        "Pytania i odpowiedzi": "Questions & Answers",
        "Pytanie": "Question",
        "Recaptcha": "Recaptcha",
        "Redaktor został zaktualizowany.": "The editor has been updated.",
        "Region": "Region",
        "Regulamin wymagany": "Regulations required",
        "Regulamin został dodany.": "Regulations have been added.",
        "Regulamin został zaktualizowany.": "Ragulations have been updated.",
        "Regulaminy": "Regulations",
        "Rejestracja konta": "Sign-up",
        "Repozytorium plików": "File repository",
        "Reżyseria": "Direction",
        "Ręczna akceptacja wszystkich komentarzy": "Manually accept all comments",
        "Ręczny wybór zdjęć lub galerii": "",
        "Rodzaj adresu kanonicznego": "Type of canonical address",
        "Rotator": "Rotator",
        "Rotator został dodany.": "Rotator has been added.",
        "Rotator został usunięty.": "The rotator has been removed.",
        "Rotator został zaktualizowany.": "The rotator has been updated.",
        "Rotatory opinii": "Opinion rotators",
        "Rozwiń do": "Expand to",
        "RSS": "RSS",
        "Scenariusz": "Scenario",
        "Sekcja": "Section",
        "Sekcja %0": "Section %0",
        "Sekcja komentarzy": "",
        "Sekcja modułu": "Module section",
        "Sekcja pod artykułem": "Section under the article",
        "Sekcja śródtekstowa": "Intra-text section",
        "Sekcje": "Sections",
        "Separator elementów w tytule": "Element separator in title",
        "Serial telewizyjny": "Television series",
        "Serie kresek lub fragmentów linii": "",
        "Serie kropek": "",
        "Shorcode nie istnieje. Usuń go z edytora.": "",
        "ShortCode został dodany.": "",
        "Shortcode został usunięty": "",
        "ShortCode został usunięty.": "",
        "ShortCode został zaktualizowany.": "",
        "Shortcodes": "",
        "Sitemapy": "",
        "Skopiowano": "Copied",
        "Skrócony opis": "Short description",
        "Skrypt": "Script",
        "Skrypty zewnętrzne": "External scripts",
        "Skrypty związane ze zbieraniem danych targetujących, np. Google Tag Manager, Pixel Facebook. Dodawany w górnej części <body> witryny.": "Scripts related to the collection of targeting data, e.g. Google Tag Manager, Facebook Pixel. Added at the top of <body> website.",
        "Skrypty związane ze zbieraniem statystyk przez usługi zewnętrzne, np. Analytics, Matomo. Dodawany w górnej części <head> witryny.": "Scripts related to the collection of statistics by external services, e.g. Analytics, Matomo. Added at the top of <head> site.",
        "Slajder": "Slider",
        "Slajder został dodany.": "The slider has been added.",
        "Slajder został usunięty.": "The slider has been removed.",
        "Slajder został zaktualizowany.": "The slider has been updated.",
        "Slajdery": "Sliders",
        "Słowa kluczowe": "Keywords",
        "Słowa oddzielone przecinkami.": "Words separated by commas.",
        "Słowo": "Word",
        "Sobota": "Saturday",
        "Sortowanie": "Sorting",
        "Sortowanie autorów": "Author sorting",
        "Sortowanie kategorii": "Sorting categories",
        "Sortowanie pakietów": "",
        "Sortuj autorów": "Sort authors",
        "Sortuj kategorie": "Sort Categories",
        "Sortuj pakiety": "",
        "Sortuj według": "",
        "Standardowa strona": "Standard page",
        "Stara cena brutto": "Old gross price",
        "Status": "Status",
        "Status aranżacji został zmieniony.": "The status of the arrangement has been changed.",
        "Status baneru został zmieniony.": "The status of the banner has been changed.",
        "Status dokumentu został zmieniony.": "The status of the document has been changed.",
        "Status galerii został zmieniony.": "The status of the gallery has been changed.",
        "Status linku został zmieniony.": "The status of the link has been changed.",
        "Status płatności": "Payment status",
        "Status regulaminu został zmieniony.": "The status of the regulations has been changed.",
        "Status użytkownika": "",
        "Status wideo został zmieniony.": "The status of the video has been changed.",
        "Status zamówienia": "Order status",
        "Status:": "Status:",
        "Statyczny": "Static",
        "Strona": "Page",
        "Strona bez modułu": "Page without module",
        "Landing page z PageBuildera": "PageBuilder landing page",
        "Strona do publikacji": "",
        "Strona docelowa dla 'Czytaj więcej'": "The landing page for 'Read more'",
        "Strona docelowa dla 'Kontakt z adminem'": "Destination page for 'Contact Admin'",
        "Strona docelowa dla 'Pliki cookies'": "Landing page for 'Cookies'",
        "Strona docelowa dla 'Polityka prywatności'": "Landing page for 'Privacy Policy'",
        "Strona dostępna dla wszystkich": "Website available to everyone",
        "Strona dostępna tylko dla zalogowanych użytkowników": "Page available only to logged in users",
        "Strona głowna": "",
        "Strona główna": "Home",
        "Strona logowania": "Login page",
        "Strona nadrzędna": "Parent page",
        "Strona opublikowana": "Published page",
        "Strona ukryta": "Hidden page",
        "Strona z błędem 404": "Page with 404 error",
        "Strona z modułu konto użytkownika": "Page from the user account module",
        "Strona z modułu wyszukiwarki": "Page from the search engine module",
        "Strona została dodana.": "The page has been added.",
        "Strona została usunięta.": "The page has been deleted.",
        "Strona została zaktualizowana.": "The page has been updated.",
        "Strona/kategoria nadrzędna": "",
        "Strony": "Page",
        "Strony gazetki": "Newspaper pages",
        "Struktura serwisu": "Site structure",
        "Studio": "Studio",
        "Subskrypcja": "Subscription",
        "Subskrypcja aktywna": "Active subscription",
        "Subskrypcje": "Subscriptions",
        "Symbol": "Symbol",
        "Symbol autora": "Author Symbol",
        "Symbol linku": "Link symbol",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku -": "The symbol can only consist of lowercase letters, numbers and the character -",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku - ": "A symbol can only consist of lowercase letters, numbers, and a character - ",
        "Symbol strony": "Page symbol",
        "Synchronizuj": "Sync",
        "System": "System",
        "System operacyjny": "",
        "Szablon graficzny": "Graphic template",
        "Szablon wiadomości": "",
        "Szablon został dodany.": "The template has been added.",
        "Szablon został usunięty.": "The template has been removed.",
        "Szablon został zaktualizowany.": "The template has been updated.",
        "Szablony": "Templates",
        "Szczegóły": "Details",
        "Szczegóły klienta": "Customer details",
        "Szczegóły wpisu": "Entry details",
        "Szczegóły zamówienia": "Order details",
        "Szerokość": "Width",
        "Szerokość strony": "Page width",
        "Szukaj": "Search",
        "Ścieżka aktywnej strony": "Path of the active page",
        "Ścieżka nawigacyjna": "Navigation path",
        "Środa": "Wednesday",
        "Środowisko": "Environment",
        "Ta aranżacja zostanie użyta jeśli nie przypisano żadnej innej aranżacji do strony.": "This arrangement will be used if no other arrangement has been assigned to the site.",
        "Tagi": "Tags",
        "Tagi nie są widoczne w przypadku zaznaczenia opcji \"Wyświetlaj tylko treść\".": "",
        "Tak": "Yes",
        "Target": "Target",
        "Tekstowy / HTML / JS": "Text / HTML / JS",
        "Testowe": "Test",
        "Tokeny": "Tokens",
        "Top temat został dodany.": "Top topic has been added.",
        "Top temat został usunięty.": "The top topic has been removed.",
        "Top temat został zaktualizowany.": "Top topic has been updated.",
        "Top tematy": "Top Topics",
        "Treść": "Content",
        "Treść artykułu": "",
        "Treść komentarza": "Comment content",
        "Treść nie może być pusta.": "The content must not be empty.",
        "Treść premium": "",
        "Tryb galerii": "",
        "Tryb wyświetlania": "Display mode",
        "Tydzień": "Week",
        "Tylko 404": "Only 404",
        "Tylko aktywne": "Only active",
        "Tylko gdy odpowiedź serwera jest 404": "Only when the server response is 404",
        "Tylko małe litery, bez znaków specjalnych, cyfr i spacji.": "Lowercase letters only, no special characters, numbers, and spaces.",
        "Tylko priorytetowe": "Priority only",
        "Tylko treść": "Content only",
        "Tylko zalogowani użytkownicy mogą zgłaszać komentarze": "Only logged-in users can report comments",
        "Typ": "Type",
        "Typ aranżacji": "Type of arrangement",
        "Typ autora": "Author type",
        "Typ bannera": "Banner type",
        "Typ długości": "Length type",
        "Typ długości pakietu": "Type of package length",
        "Typ konta": "Account type",
        "Typ obiektu:": "Object type:",
        "Typ pakietu": "Package type",
        "Typ rankingu": "Ranking type",
        "Typ strony": "Page type",
        "Typ zestawu": "Set type",
        "Tytuł": "Title",
        "Tytuł aktywnej witryny": "Title of the active site",
        "Tytuł elementu": "Element title",
        "Tytuł okładki": "Cover title",
        "Tytuł pomocniczy": "",
        "Tytuł pomocniczy jest wyświetlany przed tytułem artykułu.": "",
        "Tytuł przerwy technicznej": "Technical Break Title",
        "Tytuł strony": "Page title",
        "Tytuł witryny": "Site title",
        "Ukryj nazwę na front": "",
        "Ulica": "Street",
        "Uprawnienia": "Permissions",
        "Url": "Url",
        "URL": "URL",
        "Usatwienia komentarzy": "",
        "Ustaw kategorię": "Set category",
        "Ustaw również dla wszystkich podstron": "Set also for all subpages",
        "Ustawienia": "Settings",
        "Ustawienia domyślne": "Default settings",
        "Ustawienia dostępności": "Accessibility settings",
        "Ustawienia konta": "Account settings",
        "Ustawienia płatności": "Payment settings",
        "Ustawienia płatności zostały zaktualizowane.": "Payment settings have been updated.",
        "Ustawienia podstawowe": "Basic settings",
        "Ustawienia redakcji": "Editorial settings",
        "Ustawienia rotatora": "Rotator settings",
        "Ustawienia sekcji \"%0\"": "Settings of the \"%0\" section",
        "Ustawienia slajdera": "Slider settings",
        "Ustawienia strony": "Page settings",
        "Ustawienia witryny": "Site settings",
        "Ustawienia zostały zaktualizowane.": "The settings have been updated.",
        "Ustawienia zostały zapisane.": "Settings have been saved.",
        "Usuń": "Delete",
        "Usuń artykuł z listy": "Remove an article from the list",
        "Usuń autora": "Delete author",
        "Usuń widget z sekcji": "Remove a widget from a section",
        "Usuń charmonogram": "Remove charmonogram",
        "Usuń dokument": "",
        "Usuń katalog": "Delete directory",
        "Usuń kategorię": "Delete category",
        "Usuń odpowiedź": "Delete answer",
        "Usuń opinię": "Delete opinion",
        "Usuń plik": "Delete file",
        "Usuń powiązanie": "Unlink",
        "Usuń powód": "Remove reason",
        "Usuń publikację": "Delete a publication",
        "Usuń pytanie": "Delete question",
        "Usuń regulamin": "Delete regulations",
        "Usuń shortcode": "",
        "Usuń slajd": "Delete slide",
        "Usuń słowo": "Delete word",
        "Usuń stronę": "Delete page",
        "Usuń tag": "Remove tag",
        "Usuń wybrany element": "Delete the selected item",
        "Usuń zaznaczone": "",
        "Usuń zestaw": "Delete set",
        "Uwaga! ": "",
        "Użytkownicy mogą zgłaszać komentarze": "",
        "Użytkownicy mogą zgłaszać komentarze do moderacji": "Users can submit comments for moderation",
        "Użytkownik dokonał rejestracji samodzielnie.": "",
        "Użytkownik z bazy": "User from the base",
        "Użytkownik zalogowany": "Logged in user",
        "Użytkownikcy z bazy": "Users from the base",
        "W drodze": "",
        "W przypadku braku wartości zostanie wyświetlona nazwa strony.": "If the value is missing, the name of the site will be displayed.",
        "W przypadku zaznaczenia opcji \"Artykuł sponsorowany\" lub \"Opinia\", etykieta jest ustawiona automatycznie.": "",
        "W trakcie przygotowania": "",
        "W tym katalogu nie ma jeszcze żadnych stron.": "There are no pages in this directory yet.",
        "Walidacja": "Validation",
        "Wartość długości": "Length value",
        "Wartość tekstowa": "Text value",
        "Ważne: Moduł ten obsługuje wyłącznie linki wewnętrzne, tj. odnoszące się do zasobów w ramach tej samej domeny i serwisu. Adresy należy podawać jako pełne ścieżki, na przykład: /stara-strona oraz /nowa-strona.": "Important: This module supports only internal links, i.e. referring to resources within the same domain and site. Addresses should be given as full paths, for example: /old-page and /new-page.",
        "Wersja językowa": "Language version",
        "Wersja robocza została przywrócona.": "The draft version has been restored.",
        "Wersje": "Versions",
        "Wersje językowe": "",
        "Wewnętrzny": "Internal",
        "Wiadomość została wysłana.": "The message has been sent.",
        "Wideo": "Video",
        "Wideo nie jest jeszcze nigdzie opublikowane.": "The video is not yet published anywhere.",
        "Wideo nie ma ustawionej daty publikacji.": "The video does not have a publication date set.",
        "Wideo premium": "Premium video",
        "Wideo zostało dodane.": "Video has been added.",
        "Wideo zostało usunięte.": "The video has been removed.",
        "Wideo zostało zaktualizowane.": "The video has been updated.",
        "Widoczność": "Visibility",
        "Widok czołówki - zdjęcie z tytułem": "Front view - photo with title",
        "Więcej": "More",
        "Witryna": "Website",
        "Witryna / Wersja językowa": "Website / Language version",
        "Witryna aktywna": "Active site",
        "Witryna domyślna": "Default site",
        "Witryna i język": "Site and language",
        "Witryna internetowa": "Website",
        "Witryna tylko dla zalogowanych użytkowników": "Site for logged-in users only",
        "Witryna została dodana.": "The site has been added.",
        "Witryna została usunięta.": "The site has been removed.",
        "Witryna została zaktualizowana.": "The site has been updated.",
        "Witryny": "Sites",
        "Właściwości": "Characteristics",
        "Właściwość ``%0`` aktywnego wpisu": "The ''%0'' feature of the active entry",
        "Włącz ankietę": "Enable survey",
        "Włącz formularz kontaktowy": "Enable contact form",
        "Włącz przynajmniej jedną wersję językową dla witryny aby rozpocząć zarządzanie stronami.": "Enable at least one language version for your site to start managing your pages.",
        "Włącz social media": "Enable social media",
        "Włącz system komentarzy": "Enable the comment system",
        "Włączenie generowania pliku sitemap.xml dla całej witryny": "Enable sitemap.xml file generation for the website",
        "Włączenie obsługi cacheu": "",
        "Włączenie protokołu SSL dla tej witryny": "Enable SSL for this site",
        "Włączone (Follow)": "Enabled (Follow)",
        "Włączone (Index)": "Enabled (Index)",
        "Wpis został dodany.": "The post has been added.",
        "Wpis został usunięty.": "The post has been deleted.",
        "Wpis został zaakceptowany.": "The post has been accepted.",
        "Wpis został zaktualizowany.": "The post has been updated.",
        "Wpisy zostały usunięte.": "The entries have been deleted.",
        "Wpisy zostały zaakceptowane.": "The entries have been accepted.",
        "Wprowadź link": "Enter link",
        "Wskazuje robotom wyszukiwarek czy mają indeksować stronę.": "It indicates to search engine robots whether to index the page.",
        "Wskazuje robotom wyszukiwarek czy mają podążać za linkami.": "It indicates to search engine robots whether to follow the links.",
        "Wstaw do edytora": "",
        "Wstęp": "Introduction",
        "Wstęp nie jest widoczny w przypadku zaznaczenia opcji \"Wyświetlaj tylko treść\".": "",
        "Wszystkie": "All",
        "Wszystko": "All",
        "Wtorek": "Tuesday",
        "Wybierz": "Select",
        "Wybierz adres kanoniczny z listy lub podaj ręcznie.": "Select a canonical address from the list or enter it manually.",
        "Wybierz ankietę": "Select a survey",
        "Wybierz artykuł": "Select article",
        "Wybierz autora": "Select author",
        "Wybierz widget": "Select widget",
        "Wybierz czołówkę": "Choose a headlamp",
        "Wybierz datę": "Select a date",
        "Wybierz datę lub wprowadź wartość tekstową": "Select a date or enter a text value",
        "Wybierz daty publikacji": "Select publication dates",
        "Wybierz docelową aranżację": "",
        "Wybierz dokument": "",
        "Wybierz domyślną kategorię": "Choose a default category",
        "Wybierz etykietę": "",
        "Wybierz formularz": "Select a form",
        "Wybierz galerię": "Select a gallery",
        "Wybierz istniejącego użytkownika": "Select an existing user",
        "Wybierz język": "",
        "wybierz katalog": "select directory",
        "Wybierz kategorie": "",
        "Wybierz kategorię": "Select a category",
        "Wybierz kategorię subskrypcji": "Select a subscription category",
        "Wybierz link z serwisu": "Select a link from the site",
        "Wybierz listę regulaminów": "Select a list of regulations",
        "Wybierz regulamin": "Select regulations",
        "Wybierz sekcję": "Select section",
        "Wybierz stronę": "Select page",
        "Wybierz stronę do opublikowania": "Select a page to publish",
        "Wybierz strony": "Select pages",
        "wybierz szablon": "select template",
        "Wybierz użytkownika": "Select user",
        "Wybierz wideo": "Select video",
        "Wybierz witrynę": "",
        "Wybierz z listy": "",
        "wybierz...": "select...",
        "Wybierz...": "Select...",
        "Wybór listy stron": "Selection of the list of pages",
        "Wybór strony": "Site selection",
        "Wybrana ikona powinna być kwadratem": "The selected icon should be a square",
        "Wybrane artykuły": "Items in cart",
        "Wybrane regulaminy:": "Selected regulations:",
        "Wybrane strony": "",
        "Wybranie ankiety jest wymagane": "Selecting a survey is required",
        "Wybranie katalogu jest wymagane": "Selecting a directory is required",
        "Wybranie strony jest wymagane": "Selecting a page is required",
        "Wybraniue modułu jest wymagane": "",
        "Wybraniue sekcji jest wymagane": "",
        "Wybrano": "Selected",
        "Wybrano etykietę \"Artykuł sponsorowany\".": "",
        "Wybrano etykietę \"Opinia\".": "",
        "Wybrany język": "Selected language",
        "Wybrany szablon": "Selected template",
        "Wybrany znak zastąpi znacznik separatora | wstawiony w tytule.": "The selected character will replace the separator marker | inserted in the title.",
        "Wybróbuj możliwości AI": "Sample the capabilities of AI",
        "Wygeneruj definicję szablonu w aplikacji frontendowej za pomocą asystenta komend `npm run edito` i wklej poniżej zawartość wygenerowanego pliku `theme.json` właściwego dla szablonu.": "",
        "Wygląd": "Look",
        "Wykonawca": "Author",
        "Wyłącz cenę": "Turn off the price",
        "Wyłącz cenę z historii": "Exclude price from history",
        "Wyłącz system komentarzy": "",
        "Wyłącz udostępnianie": "",
        "Wyłączone (NoFollow)": "Off (NoFollow)",
        "Wyłączone (NoIndex)": "Disabled (NoIndex)",
        "Wyłączone komentarze": "Comments Off on",
        "Wyłączone przez": "Excluded by",
        "Wyłączone udostępnianie": "Disabled sharing",
        "Wymagaj ponownej akceptacji po zmianach": "Require re-approval after changes",
        "Wymagane jest wybranie sekcji": "A section must be selected",
        "Wymagane jest wybranie wersji językowej": "It is required to select the language version",
        "Wymagane jest wybranie witryny": "It is required to select a site",
        "Wymagane jest wybranie zestawu regulaminów": "It is required to select a set of regulations",
        "Wymiar": "",
        "Wyniki": "Results",
        "Wyniki_": "Results_",
        "Wyrażone zgody": "Consents given",
        "Wysłane": "Sent",
        "Wysoki": "High",
        "Wysokość": "Height",
        "Wysokość strony": "Page height",
        "Wystąpił błąd podczas próby exportu przekierowań.": "An error occurred while trying to export redirects.",
        "Wystąpił błąd podczas próby importu przekierowań.": "An error occurred while trying to import redirects.",
        "Wystąpiły błędy w formularzu. Sprawdź wszystkie pola formularza.": "There were errors in the form. Check all fields of the form.",
        "Wyszukaj": "Search",
        "Wyszukaj albo dodaj nową kategorię": "Search or add a new category",
        "Wyszukaj albo dodaj nowy tag": "Search for or add a new tag",
        "Wyszukaj autora...": "Search for author...",
        "Wyszukaj widget": "Search widgets",
        "Wyszukaj czołówkę...": "Search headline...",
        "Wyszukaj kategorię": "Search a category",
        "Wyszukaj regulamin...": "Search for regulations...",
        "Wyszukaj tag": "Search tag",
        "Wyszukiwanie zwraca tylko zaakceptowane wersje regulaminów": "",
        "Wyślij powiadomienie - Ilość dni po zakończeniu subskrypcji:": "Send notification - Number of days after subscription ends:",
        "Wyślij powiadomienie - Ilość dni przed zakończeniem subskrypcji:": "Send notification - Number of days before your subscription ends:",
        "Wyślij wiadomość": "Send message",
        "Wyświetlaj artykuł na całą stronę": "Display article for full page",
        "Wyświetlaj listę artykułów z miniaturką zdjęcia": "Display a list of articles with a thumbnail image",
        "Wyświetlaj nazwę widgetu": "Display widget name",
        "Wyświetlaj opinie z tłem": "Display feedback with background",
        "Wyświetlaj tylko treść": "Display content only",
        "Wyświetlaj tytuł": "Display title",
        "Wyświetlenia": "",
        "wyświetleń": "",
        "Wyżej": "Above",
        "Wzory": "",
        "YouTube (ID)": "YouTube (ID)",
        "Zaakceptowane wersje": "",
        "Zaakceptowany": "Accepted",
        "Zaawansowane polecenia": "Advanced commands",
        "zacznij pisać aby wyszukać ankietę...": "start typing to search for a survey....",
        "zacznij pisać aby wyszukać ankiety...": "start writing to search for surveys....",
        "zacznij pisać aby wyszukać artykuł...": "start typing to search for an article...",
        "zacznij pisać aby wyszukać autora...": "start typing to search for an author...",
        "zacznij pisać aby wyszukać dokument...": "",
        "zacznij pisać aby wyszukać galerię...": "start typing to search the gallery....",
        "zacznij pisać aby wyszukać grupę...": "start writing to search for a group....",
        "zacznij pisać aby wyszukać kategorię...": "start typing to search for a category...",
        "zacznij pisać aby wyszukać rotator...": "start typing to search for rotator....",
        "zacznij pisać aby wyszukać slajder...": "start typing to search for a slider...",
        "zacznij pisać aby wyszukać użytkownika...": "start typing to search for a user...",
        "zacznij pisać aby wyszukać wideo...": "start typing to search for video....",
        "Zaimportowano listę przekierowań.": "A list of redirects has been imported.",
        "Zakończone": "Completed",
        "Zakres dat": "",
        "Zaktualizowano.": "Updated.",
        "Załączniki": "Attachments",
        "Załączniki premium": "Premium attachments",
        "Zamiany zostały zapisane.": "The changes have been saved.",
        "Zamknij": "Close",
        "Zamówienia": "Orders",
        "Zamówienie": "Order",
        "Zamówienie zostało zaktualizowane.": "The order has been updated.",
        "Zamówiony pakiet": "Ordered package",
        "Zapisz": "Save",
        "Zapisz i wróć": "Save and return",
        "Zapisz zmiany": "Save changes",
        "Zaplanowane": "Scheduled",
        "Zapytanie AI": "",
        "Zapytanie EQL": "",
        "Zapytanie użytkownika": "",
        "Zarządzanie": "",
        "Zarządzanie witrynami": "Manage sites",
        "Zatwierdź": "Approve",
        "Zatwierdź zaznaczone": "",
        "Zawiera sekcje": "Contains sections",
        "Zawierające jeden z wybranych tagów": "Containing one of the selected tags",
        "Zawsze": "Always",
        "Zaznacz wszystkie": "Select all",
        "Zaznaczone": "Marked",
        "Zaznaczone (${checkedItems.value.length})": "Selected (${checkedItems.value.length})",
        "Zdjęcia": "Photos",
        "Zdjęcia premium": "",
        "Zdjęcie": "Photo",
        "Zdjęcie autora": "Photo by the author",
        "Zdjęcie dla tabletów": "Photo for tablets",
        "Zdjęcie dla urządzeń mobilnych": "Photo for mobile devices",
        "Zdjęcie główne": "Main photo",
        "Zdjęcie główne nie jest widoczne w przypadku zaznaczenia opcji \"Wyświetlaj tylko treść\".": "",
        "Zdjęcie na okładce": "Cover photo",
        "Zdjęcie użytkownika": "User's photo",
        "Zdjęcie w tle": "Background photo",
        "Zdjęcie/ikonka": "",
        "Zestaw": "Set",
        "Zestaw niestandardowy": "Custom set",
        "Zestaw został dodany.": "The set has been added.",
        "Zestaw został zaktualizowany.": "The set has been updated.",
        "Zewnętrzne skrypty statystyk": "External statistics scripts",
        "Zewnętrzne skrypty targetujące": "External targeting scripts",
        "Zewnętrzny": "External",
        "Zewnętrzny serwis": "External service",
        "Zgłaszanie komentarzy": "Reporting comments",
        "Zgłoszenia": "Issues",
        "Zmiana formularza nie będzie możliwa po zapisaniu ShortCode": "",
        "Zmiana symbolu powoduje również zmianę adresu URL.": "",
        "Zmiany w tym widoku bezpośrednio wpływają na funkcjonowanie aplikacji frontend. Przed edycją jakichkolwiek danych upewnij się, że są one przemyślane i uzasadnione. Niewłaściwa modyfikacja może skutkować nieprawidłowym działaniem aplikacji.": "",
        "Zmiany zostały zapisane.": "Changes saved.",
        "Zmieną %HEAD_TITLE% można wykorzystać w innych polach tekstowych.": "The variable %HEAD_TITLE% can be used in other text boxes.",
        "Zmień daty publikacji": "Change publication dates",
        "Znajdź typ widgetu...": "Find the type of widget...",
        "Zobacz przed opublikowaniem": "View before publishing",
        "Zobacz wszystkich użytkowników": "",
        "Zobacz wszystkie artykuły": "",
        "Zobacz wszystkie komentarze": "",
        "Zobacz wszystkie wpisy": "",
        "Zrezygnowano z subskrypcji": "Subscriptions cancelled",
        "Zwrot do nadawcy": "",
        "Źródło URL": "URL source",
        "Ustawienia widgetu": "Widget settings",
        "Pokaż więcej": "Show more",
        "Widget Studio": "Studio widget"
    }
};
